import { addTodo, setSubject } from '../actions/quickAddActions';
import { addTodosToFolderView, todosAdded } from '../actions/todoFolderViewActions';
import { createTodo } from '../store/schema/Todo';
import { getGuid } from 'owa-guid';
import { orchestrator } from 'satcheljs';
import handleCreateTodos from './handleCreateTodos';
import now from 'owa-datetime/lib/userDate/now';

export const addTodoOrchestrator = orchestrator(addTodo, async actionMessage => {
    // Local lie for this task.
    const todo = createTodo({
        Id: getGuid(),
        Subject: actionMessage.subject,
        OrderDateTime: now(),
    });
    addTodosToFolderView([todo], false /* deleteAll */, true /* addToFront */);

    // Reset the subject
    setSubject('');

    // Kick off the add todo action.
    await handleCreateTodos([todo], actionMessage.folderId);

    // reload the folder irrespective of success.
    todosAdded();
});
